<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-1 texto-titulo">
          Listagem de Transferências Mrp
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-sm q-mb-lg container-inputs"
    >
      <div>
        <q-btn
          label="Criar"
          icon="add"
          color="positive"
          no-caps
          class="q-mt-sm btn"
          @click="rightDrawerOpen = true"
        />
      </div>
    </div>

    <div
      class="row col-12 q-col-gutter-sm items-center text-brand-5 text-weight-bold q-mt-md container-inputs"
    >
      <div class="col-md-3 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Estoque Origem</div>
        <q-select
          v-model="filtros.unidadeOrigem"
          dense
          outlined
          :options="optionsUnidade"
          class="select input-new-design"
          :display-value="
            filtros.unidadeOrigem
              ? filtros.unidadeOrigem.nome
              : 'Selecione a Unidade'
          "
          option-value="id"
          option-label="nome"
        />
      </div>
      <div class="col-md-3 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Estoque Destino</div>
        <q-select
          v-model="filtros.unidadeDestino"
          dense
          outlined
          :options="optionsUnidade"
          class="select input-new-design"
          :display-value="
            filtros.unidadeDestino
              ? filtros.unidadeDestino.nome
              : 'Selecione a Unidade'
          "
          option-value="id"
          option-label="nome"
        />
      </div>
      <div class="col-md-3 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Status</div>
        <q-select
          v-model="filtros.status"
          :options="optionsStatus"
          dense
          outlined
          class="select input-new-design"
        />
      </div>
      <div class="col-md-3 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Tipo de Transação</div>
        <q-select
          v-model="filtros.tipoTransacao"
          dense
          outlined
          :options="options.optionsTipoTransacao"
          class="select input-new-design"
          option-value="value"
          option-label="label"
        />
      </div>
      <div class="col-md-3 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Movimentação Estoque</div>
        <q-select
          v-model="filtros.movimentacaoEstoque"
          dense
          outlined
          :options="options.optionsMovimentacaoEstoque"
          class="select input-new-design"
          option-value="value"
          option-label="label"
        />
      </div>
      <div class="col-md-3 col-sm-5 col-xs-5 text-weight-bold">
        <div class="q-ml-sm texto-titulo-input">Data Inicial</div>
        <q-input
          dense
          outlined
          class="input input-new-design"
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
          v-model="filtros.dataInicial"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="filtros.dataInicial"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="col-md-3 col-sm-5 col-xs-5 text-brand-5 text-weight-bold">
        <div class="q-ml-sm texto-titulo-input">Data Final</div>
        <q-input
          dense
          v-model="filtros.dataFinal"
          outlined
          class="input input-new-design"
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="filtros.dataFinal"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div>
        <p></p>
        <q-btn
          label="Filtrar"
          icon="filter_alt"
          no-caps
          style="background-color: #21324a; border-radius: 8px; color: white"
          class="q-mt-xs"
          @click="listarTransferencias()"
        />
      </div>
    </div>

    <div class="q-mt-xl">
      <q-table
        :columns="columns"
        :loading="loading"
        :rows="listaTransferencias"
        color="primary"
        dense
        table-header-class="bg-accent text-weight-bold"
        flat
        hide-bottom
        hide-pagination
        class="tabela-tamanho-fixo"
        :grid="$q.screen.lt.sm"
        :rows-per-page-options="[0]"
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Minhas Transferências</span
          >
        </template>
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            type="text"
            class="col-md-3 col-xs-10"
            placeholder="Pesquisar"
            v-model="filtros.numero"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-7">
                  <div class="row col-12 q-ml-sm q-mt-sm">
                    <span class="q-mr-sm"
                      ><strong class="q-mr-xs">ID: </strong>
                      {{ props.row.id }}</span
                    >
                  </div>
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Requisitante: </strong>
                    {{ props.row.nome_usuario }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Descrição: </strong>
                    <span
                      v-if="
                        props.row.transaction_type == 'vendor_vendor_divergente'
                      "
                    >
                      Transferencia Criada a partir de Recebimento Divergente
                    </span>
                    <span v-if="props.row.transaction_type == 'vendor_vendor'">
                      Transferencia Criada entre Estoques
                    </span>
                    <span
                      v-if="
                        props.row.transaction_type ==
                        'vendor_vendor_sem_movimentacao'
                      "
                    >
                      Transferencia Criada por Requisição
                    </span></span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Estoque Origem: </strong>
                    {{ props.row.nome_unidade_saida }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Estoque Destino: </strong>
                    {{ props.row.nome_unidade_entrada }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Produtos: </strong>
                    {{ props.row.quant_produtos }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Criada Em: </strong>
                    {{
                      props.row.data_criacao
                        .split(" ")[0]
                        .split("-")
                        .reverse()
                        .join("/")
                    }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Status: </strong>
                    {{ props.row.status }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Mov. Estoque: </strong>
                    {{ props.row.movimentou_estoque }}</span
                  >
                </div>
                <div class="col-5">
                  <div class="row col-12 justify-end q-gutter-x-sm">
                    <q-btn
                      color="blue-6"
                      @click="
                        detalharTransferencia(props.row.id, props.row.status)
                      "
                      round
                      size="md"
                      icon="add"
                    />
                    <q-btn icon="print" flat round size="md" />
                    <q-btn
                      icon="delete"
                      flat
                      round
                      color="red"
                      size="md"
                      @click="
                        receberDadosDeletar(props.row.id), (confirm = true)
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-id="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.id }}
          </q-td>
        </template>
        <template v-slot:body-cell-requisitante="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.nome_usuario }}
          </q-td>
        </template>
        <template v-slot:body-cell-descricao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <span
              v-if="props.row.transaction_type == 'vendor_vendor_divergente'"
            >
              Transferencia Criada a partir de Recebimento Divergente
            </span>
            <span v-if="props.row.transaction_type == 'vendor_vendor'">
              Transferencia Criada entre Estoques
            </span>
            <span
              v-if="
                props.row.transaction_type == 'vendor_vendor_sem_movimentacao'
              "
            >
              Transferencia Criada por Requisição
            </span>
          </q-td>
        </template>
        <template v-slot:body-cell-estoqueOrigem="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.nome_unidade_saida }}
          </q-td>
        </template>
        <template v-slot:body-cell-estoqueDestino="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.nome_unidade_entrada }}
          </q-td>
        </template>
        <template v-slot:body-cell-produtos="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.quant_produtos }}
          </q-td>
        </template>
        <template v-slot:body-cell-criadaEm="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{
              props.row.data_criacao
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}
          </q-td>
        </template>
        <template v-slot:body-cell-status="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.status }}
          </q-td>
        </template>
        <template v-slot:body-cell-movimentacaoEstoque="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.movimentou_estoque }}
          </q-td>
        </template>
        <template v-slot:body-cell-detalhes="props">
          <q-td :props="props">
            <q-btn
              color="blue-6"
              round
              size="sm"
              icon="add"
              @click="detalharTransferencia(props.row.id, props.row.status)"
            />
          </q-td>
        </template>
        <template v-slot:body-cell-imprimir="props">
          <q-td :props="props">
            <router-link
              :to="{
                name: 'transferencia-imprimir',
                params: { transferenciaId: props.row.id },
              }"
            >
              <q-btn color="black" icon="print" flat />
            </router-link>
          </q-td>
        </template>
        <template v-slot:body-cell-deletar="props">
          <q-td :props="props">
            <q-btn
              icon="delete"
              flat
              color="red"
              @click="receberDadosDeletar(props.row.id), (confirm = true)"
            />
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
    <q-dialog v-model="confirm" persistent>
      <q-card class="q-pa-sm text-brand-5 text-weight-bolder">
        <q-card-section class="row items-center">
          <span class="q-ml-sm"
            >Tem certeza que deseja deletar essa transferência?
          </span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            icon="cancel"
            no-caps
            dense
            outline
            label="Não"
            color="negative"
            v-close-popup
          />
          <q-btn
            no-caps
            dense
            outline
            label="Sim"
            color="positive"
            v-close-popup
            icon="check_circle_outline"
            @click="deletarTransferencia()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <ModalInformacaoesAdicionais
      :rightDrawerOpen="rightDrawerOpen"
      :nomeModal="'Criar Transferência'"
      @fecharModal="rightDrawerOpen = false"
    >
      <template v-slot:conteudo-modal>
        <div class="col-12">
          <div class="q-ml-sm texto-titulo-input">Estoque Origem*</div>
          <q-select
            v-model="criarTransferenciaDados.unidadeOrigem"
            dense
            outlined
            :options="optionsUnidade"
            class="select"
            :display-value="
              criarTransferenciaDados.unidadeOrigem
                ? criarTransferenciaDados.unidadeOrigem.nome
                : 'Selecione a Unidade'
            "
            option-value="id"
            option-label="nome"
          />
        </div>
        <div class="col-12 q-mt-sm">
          <div class="q-ml-sm texto-titulo-input">Estoque Destino*</div>
          <q-select
            v-model="criarTransferenciaDados.unidadeDestino"
            dense
            outlined
            :options="optionsUnidade"
            class="select"
            :display-value="
              criarTransferenciaDados.unidadeDestino
                ? criarTransferenciaDados.unidadeDestino.nome
                : 'Selecione a Unidade'
            "
            option-value="id"
            option-label="nome"
          />
        </div>
      </template>
      <template v-slot:botao-modal>
        <div>
          <q-btn
            label="Criar"
            no-caps
            color="positive"
            icon="add"
            @click="criarTransferencia()"
          />
        </div>
      </template>
    </ModalInformacaoesAdicionais>
    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>
  </q-page>
</template>

<script>
import { onMounted, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useQuasar } from "quasar";

import ModalInformacaoesAdicionais from "../../../requisicao/components/ModalInformacaoesAdicionais.vue";

const columns = [
  {
    name: "id",
    label: "ID",
    align: "left",
  },
  {
    name: "requisitante",
    label: "Requisitante",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "estoqueOrigem",
    label: "Estoque Origem",
    align: "left",
  },
  {
    name: "estoqueDestino",
    label: "Estoque Destino",
    align: "left",
  },
  {
    name: "produtos",
    label: "Produtos",
    align: "left",
  },
  {
    name: "criadaEm",
    label: "Criada Em",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    align: "left",
  },
  {
    name: "movimentacaoEstoque",
    label: "Mov. Estoque",
    align: "left",
  },
  {
    name: "detalhes",
    label: "Detalhes",
    align: "center",
  },
  {
    name: "imprimir",
    label: "Imprimir",
    align: "center",
  },
  {
    name: "deletar",
    label: "Deletar",
    align: "center",
  },
];

export default {
  components: { ModalInformacaoesAdicionais },

  setup() {
    const store = useStore();
    const router = useRouter();
    const quasar = useQuasar();

    const filtros = ref({
      dataInicial: "",
      dataFinal: "",
      unidadeOrigem: "",
      unidadeDestino: "",
      status: { label: "Enviados", value: "enviado" },
      numero: "",
      tipoTransacao: { label: "", value: "" },
      movimentacaoEstoque: { label: "", value: "" },
    });
    const optionsUnidade = ref([]);
    const optionsStatus = ref([
      { label: "Enviados", value: "enviado" },
      { label: "Cancelados", value: "cancelado" },
      { label: "Criados", value: "criado" },
      { label: "Rascunho", value: "rascunho" },
      { label: "Recebido Diferente", value: "recebido_diferente" },
      { label: "Recebidos", value: "recebido" },
    ]);
    const options = ref({
      optionsTipoTransacao: [
        { label: "Divergência", value: "vendor_vendor_divergente" },
        { label: "Estoque", value: "vendor_vendor" },
        { label: "Requisição", value: "vendor_vendor_sem_movimentacao" },
      ],
      optionsMovimentacaoEstoque: [
        { label: "Sim", value: "sim" },
        { label: "Não", value: "nao" },
      ],
    });
    const listaTransferencias = ref([]);
    let loading = ref(false);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    let disable = ref(false);
    let confirm = ref(false);
    let idDeletar = ref("");
    const rightDrawerOpen = ref(false);
    const criarTransferenciaDados = ref({
      unidadeOrigem: "",
      unidadeDestino: "",
    });

    const listarTransferencias = async (page = 0, rowsPerPage = 10) => {
      store.dispatch("pdt/hiddenHeader", true);
      try {
        loading.value = true;
        disable.value = true;
        const response = await store.dispatch(
          "transferencia/listarTransferencias",
          {
            data_inicial: filtros.value.dataInicial,
            status: filtros.value.status.value,
            vendor_id_out: filtros.value.unidadeOrigem.id,
            vendor_id_in: filtros.value.unidadeDestino.id,
            data_final: filtros.value.dataFinal,
            numero: filtros.value.numero,
            per_page: rowsPerPage,
            page: page,
            movimentou_estoque: filtros.value.movimentacaoEstoque?.value,
            transaction_type: filtros.value.tipoTransacao?.value,
          }
        );
        listaTransferencias.value = response.data.result.data;
        pagination.value.rowsPerPage = response.data.result.per_page;
        pagination.value.page = response.data.result.current_page;
        pagination.value.rowsNumber = response.data.result.total;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const listarUnidades = async () => {
      try {
        const response = await store.dispatch("org/listarUnidades");
        optionsUnidade.value = response.listaUnidades;
      } catch (error) {
        console.log(error);
      }
    };

    const criarTransferencia = async () => {
      if (
        criarTransferenciaDados.value.unidadeDestino == "" ||
        criarTransferenciaDados.value.unidadeOrigem == ""
      ) {
        quasar.notify({
          message:
            "Você precisa selecionar estoque de origem e de destino antes de criar uma nova transferência!",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        const response = await store.dispatch(
          "transferencia/criarTransferencia",
          {
            deposito_id_entrada:
              criarTransferenciaDados.value.unidadeDestino.id,
            deposito_id_saida: criarTransferenciaDados.value.unidadeOrigem.id,
          }
        );
        quasar.notify({
          message:
            "Transferência criada, você será direcionado para que possa acrescentar os produtos.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        router.push({
          name: "transferencia-detalhe-mrp",
          params: { transferenciaId: response.data.result.id },
        });
      } catch (error) {
        console.log(error);
      }
    };

    const detalharTransferencia = (id, status) => {
      console.log(status);
      if (status == "criado") {
        router.push({
          name: "transferencia-detalhe-mrp",
          params: { transferenciaId: id },
        });
        return;
      }
      if (status == "rascunho") {
        router.push({
          name: "transferencia-detalhe-mrp",
          params: { transferenciaId: id },
        });
        return;
      }

      router.push({
        name: "transferencia-detalhe",
        params: { transferenciaId: id },
      });
    };

    const deletarTransferencia = async () => {
      const response = await store.dispatch(
        "transferencia/deletarTransferencia",
        {
          id: idDeletar.value,
        }
      );
      if (response.data.result.error) {
        quasar.notify({
          message: response.data.result.error,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      quasar.notify({
        message: "Transferência deletada com sucesso",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
      listarTransferencias();
    };

    const gerarData = () => {
      let hoje = new Date();
      hoje.setMonth(hoje.getMonth() - 1);
      hoje.setDate(hoje.getDate() - 2);
      let dia = hoje.getDate();
      let mes = hoje.getMonth() + 1;
      let ano = hoje.getFullYear();

      let data =
        dia.toString().padStart(2, "0") +
        "/" +
        mes.toString().padStart(2, "0") +
        "/" +
        ano.toString();
      filtros.value.dataInicial = data;
      listarTransferencias();
    };

    const receberDadosDeletar = (id) => {
      idDeletar.value = id;
    };

    watch(
      () => pagination.value.page,
      () => {
        listarTransferencias(
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      }
    );

    watch(
      () => filtros.value.numero,
      () => {
        listarTransferencias();
      }
    );

    onMounted(listarUnidades);
    onMounted(gerarData);

    return {
      columns,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      filtros,
      listarUnidades,
      optionsUnidade,
      optionsStatus,
      listarTransferencias,
      listaTransferencias,
      loading,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      disable,
      criarTransferencia,
      detalharTransferencia,
      gerarData,
      deletarTransferencia,
      idDeletar,
      receberDadosDeletar,
      confirm,
      options,
      rightDrawerOpen,
      criarTransferenciaDados,
    };
  },
};
</script>

<style scoped>
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
a {
  text-decoration: none;
}
.texto-titulo-input {
  color: #21324a;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
    color: #21324a;
  }

  .input {
    font-size: 12px;
  }
  .select {
    font-size: 12px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
}
</style>

<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
